module.exports = __webpack_public_path__ + "static/media/logo-icon.05c2a329.svg";